module.exports = __webpack_public_path__ + "img/21_62.ce8187c7.png";